function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "769px",
    height: "505px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947
    },
    fill: "#8f8f8f",
    d: "M 43.5,-0.5 C 270.833,-0.5 498.167,-0.5 725.5,-0.5C 749.039,2.37368 763.373,15.3737 768.5,38.5C 768.5,181.167 768.5,323.833 768.5,466.5C 763.712,485.956 751.712,498.623 732.5,504.5C 500.167,504.5 267.833,504.5 35.5,504.5C 16.2923,498.626 4.29227,485.96 -0.5,466.5C -0.5,323.833 -0.5,181.167 -0.5,38.5C 5.39996,15.5996 20.0666,2.59959 43.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 40.5,7.5 C 269.5,7.33333 498.5,7.5 727.5,8C 744.346,11.1784 755.18,21.0117 760,37.5C 760.667,180.167 760.667,322.833 760,465.5C 756.202,482.631 745.702,493.131 728.5,497C 498.833,497.667 269.167,497.667 39.5,497C 22.3244,493.158 11.8244,482.658 8,465.5C 7.33333,322.833 7.33333,180.167 8,37.5C 13.0031,20.9904 23.8365,10.9904 40.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#03589f",
    d: "M 466.5,154.5 C 487.459,152.876 507.792,155.542 527.5,162.5C 527.833,163.333 528.167,164.167 528.5,165C 525.688,177.705 523.688,190.539 522.5,203.5C 512.849,199.562 502.849,196.729 492.5,195C 484.167,194.333 475.833,194.333 467.5,195C 460.066,196.441 454.232,200.274 450,206.5C 448.705,211.669 449.872,216.169 453.5,220C 468.833,228.667 484.167,237.333 499.5,246C 524.207,265.967 528.374,289.8 512,317.5C 500.776,331.871 486.276,341.371 468.5,346C 436.583,353.316 405.249,351.483 374.5,340.5C 375.612,326.157 377.945,311.823 381.5,297.5C 404.899,310.508 429.565,313.675 455.5,307C 464.973,303.221 468.473,296.388 466,286.5C 464.542,284.04 462.709,281.873 460.5,280C 449.483,273.491 438.15,267.491 426.5,262C 415.049,255.549 405.882,246.716 399,235.5C 390.827,211.018 396.66,190.518 416.5,174C 431.594,163.25 448.261,156.75 466.5,154.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#80abcf",
    d: "M 246.5,158.5 C 264.671,157.173 283.004,157.173 301.5,158.5C 301.376,159.107 301.043,159.44 300.5,159.5C 282.674,158.503 264.674,158.17 246.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f81b7",
    d: "M 373.5,158.5 C 356.09,158.181 338.756,158.515 321.5,159.5C 329.807,158.169 338.473,157.502 347.5,157.5C 356.34,157.5 365.007,157.834 373.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8a620",
    d: "M 188.5,257.5 C 173.775,225.108 150.775,200.442 119.5,183.5C 102.409,173.463 84.0759,166.463 64.5,162.5C 64.4208,161.07 64.7542,159.736 65.5,158.5C 93.8275,157.333 122.161,157.167 150.5,158C 160.783,157.629 167.95,162.129 172,171.5C 177.754,199.348 183.587,227.181 189.5,255C 189.472,256.07 189.139,256.903 188.5,257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#02589f",
    d: "M 246.5,158.5 C 264.674,158.17 282.674,158.503 300.5,159.5C 273.279,221.942 246.612,284.608 220.5,347.5C 201.833,347.5 183.167,347.5 164.5,347.5C 149.753,292.766 134.753,238.099 119.5,183.5C 150.775,200.442 173.775,225.108 188.5,257.5C 189.32,259.14 190.153,260.807 191,262.5C 192.156,270.282 193.823,277.949 196,285.5C 212.762,243.027 229.596,200.694 246.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#02589f",
    d: "M 373.5,158.5 C 363.217,220.864 352.717,283.197 342,345.5C 324.738,347.478 307.238,348.145 289.5,347.5C 300.073,284.827 310.739,222.161 321.5,159.5C 338.756,158.515 356.09,158.181 373.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#02589f",
    d: "M 702.5,345.5 C 687.202,347.484 671.536,348.151 655.5,347.5C 652.655,338.46 650.655,329.127 649.5,319.5C 627.157,319.167 604.823,319.5 582.5,320.5C 578.366,329.238 575.033,338.238 572.5,347.5C 554.164,347.667 535.83,347.5 517.5,347C 543.385,289.35 568.885,231.517 594,173.5C 597.323,166.246 602.823,161.412 610.5,159C 627.497,158.5 644.497,158.333 661.5,158.5C 675.296,220.813 688.962,283.146 702.5,345.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfcfd",
    d: "M 639.5,277.5 C 633.034,278.83 626.201,279.497 619,279.5C 611.992,279.5 605.158,279.166 598.5,278.5C 606.846,255.626 615.679,232.96 625,210.5C 629.903,232.849 634.736,255.183 639.5,277.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b7cfe3",
    d: "M 639.5,277.5 C 640.404,278.209 640.737,279.209 640.5,280.5C 626.151,280.833 611.818,280.499 597.5,279.5C 597.624,278.893 597.957,278.56 598.5,278.5C 605.158,279.166 611.992,279.5 619,279.5C 626.201,279.497 633.034,278.83 639.5,277.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bcd3e5",
    d: "M 702.5,345.5 C 703.404,346.209 703.737,347.209 703.5,348.5C 687.325,348.83 671.325,348.496 655.5,347.5C 671.536,348.151 687.202,347.484 702.5,345.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.2f4f84f357d90a60e2d2b84800d5fa1f.svg";
export { ForwardRef as ReactComponent };